// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"147":"221be881","499":"1bec27cd"}[chunkId] + ".js";
};